<template>
  <div class="about min-h-screen dark:bg-gray-900 dark:text-gray-300">
    <div class="pb-12 dark:bg-gray-900">
      <BizCover />
      <BizLogo />
      <BizDetails class="pt-6" />
      <BizStore v-if="status === 'active'" class="mt-10" />
      <BizChat class="mt-10" />
      <BizLinks class="mt-10" />
      <BizAddress class="mt-10" />
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useVepaarStore } from "@/store/store.js";
import { useHeadAndMeta } from "@/composables/headAndMeta";

export default {
  setup() {
    definePageMeta({
      scrollToTop: true,
    });

    const headAndMeta = useHeadAndMeta();
    useHead(headAndMeta);

    const head = useLocaleHead({
      addDirAttribute: true,
    });

    useHead(head);
  },

  computed: {
    ...mapState(useVepaarStore, ["status"]),
  },
};
</script>
